import React from 'react'
import { Container, Flex, Box, css, Text, Button } from 'theme-ui'
import ContentText from '@solid-ui-components/ContentText'
import Reveal from '@solid-ui-components/Reveal'
import Divider from '@solid-ui-components/Divider'
import ContentImages from '@solid-ui-components/Educabot/ContentImages'
import QuickSignupForm from '@solid-ui-components/Educabot/QuickSignupForm/QuickSignupForm'
import ContentButtons from '@solid-ui-components/ContentButtons/ContentButtons'
import WithDefaultContent from '@solid-ui-blocks/WithDefaultContent'

import Animate from '../../../../../../../site/content/assets/flexiblocks/homepage/educabot/animates.svg'

const style = {
  tecnology: {
    fontWeight: 600,
    '@media (max-width: 600px)': {
      fontSize: '35px'
    },
    '@media (max-width: 450px)': {
      fontSize: '30px'
    },
  },
  subTitle: {
    fontWeight: 600,
    color: '#FFFFFF',
    fontSize: '35px',
    '@media (max-width: 600px)': {
      fontSize: '35px'
    },
    '@media (max-width: 450px)': {
      fontSize: '30px'
    },
  }
}

const HeroBlock01 = ({
  content: { text = [], images, buttons, form },
  reverse
}) => (
  <Container sx={style.header}>
    {/* <Box className="wave" style="height: 150px; overflow: hidden;" ><svg viewBox="0 0 500 150" preserveAspectRatio="none" style="height: 100%; width: 100%;"><path d="M0.28,106.08 C215.85,-13.31 248.59,150.48 500.84,136.67 L515.52,166.28 L0.00,150.00 Z" style="stroke: none; fill: #08f;"></path></svg></Box> */}
    <Flex
      sx={{
        alignItems: [null, null, null, `center`],
        flexDirection: [
          reverse ? `column-reverse` : `column`,
          null,
          null,
          reverse ? `row-reverse` : `row`,
        ]
      }}
    >
      <Box
        sx={{
          flexBasis: [null, null, null, `3/5`],
          [reverse ? 'ml' : 'mr']: [null, null, null, 5],
          position: `relative`,
          textAlign: `center`
        }}
      >
        <ContentImages
          content={{ images }}
          loading='eager'
          reverse={reverse}
          imagePosition='center'
        />
      </Box>
      <Box
        sx={{
          flexBasis: `2/5`,
          textAlign: [`center`, 'center', 'center', `left`]
        }}
      >
        <Reveal effect='fadeInDown'>
          <ContentText sx={style.tecnology} content={text} />
          <Text sx={style.subTitle}>para liderar la transformación digital <br />en las aulas</Text>
        </Reveal>
        {buttons && (
          <Reveal
            effect='fadeInRight'
            delay={1}
            css={css({ mb: [4, null, null, 0] })}
          >
            {buttons && (
              <>
                <Divider space={4} />
                <Box
                  type="text"
                  onClick={() => window.scrollTo({top: 650, behavior: 'smooth'})}
                  css={css({ borderRadius: '5px'})}
                >
                  <ContentButtons content={buttons} />
                </Box>
              </>
            )}
          </Reveal>
        )}
        {form && (
          <Reveal
            effect='fadeInRight'
            delay={1}
            css={css({ mb: [4, null, null, 0] })}
          >
            <QuickSignupForm {...form} space={3} />
          </Reveal>
        )}
      </Box>
    </Flex>
  </Container>
)


export default WithDefaultContent(HeroBlock01)
